import actions from './actions';

const initState = {
	idToken: null,
	requestingPasswordReset: false,
	passwordResetRequestSuccessData: {},
	passwordResetRequestFailedData: {},
	requestingChangePassword: false,
	changePasswordRequestData: {},
	changePasswordRequestFailedData: {},
	verfiyActivationValid: true,
	setPasswordSucceeded: null
};

export default function authReducer(state = initState, action) {
	switch (action.type) {
		case actions.LOGIN_SUCCESS:
			return {
				...state,
				idToken: action.payload.token,
			};
		case actions.REGISTER_SUCCESS:
			return {
				...state,
				idToken: action.payload.token,
			};
		case actions.LOGOUT:
			return initState;

		case actions.REQUEST_PASSWORD_RESET:
			return {
				...state,
				requestingPasswordReset: true
			}
		case actions.REQUEST_PASSWORD_RESET_SUCCESS:
			return {
				...state,
				requestingPasswordReset: false,
				passwordResetRequestSuccessData: action.payload,
				passwordResetRequestFailedData: {}
			}
		case actions.REQUEST_PASSWORD_RESET_FAILED:
			return {
				...state,
				requestingPasswordReset: false,
				passwordResetRequestSuccessData: {},
				passwordResetRequestFailedData: action.payload
			}
		case actions.RESET_PASSWORD_RESET_DATA:
			return {
				...state,
				requestingPasswordReset: false,
				passwordResetRequestSuccessData: {},
				passwordResetRequestFailedData: {}
			}

		case actions.REQUEST_CHANGE_PASSWORD:
			return {
				...state,
				requestingChangePassword: true
			}

		case actions.REQUEST_CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				requestingChangePassword: false,
				changePasswordRequestData: action.payload,
				changePasswordRequestFailedData: {}
			}

		case actions.REQUEST_CHANGE_PASSWORD_FAILED:
			return {
				...state,
				requestingChangePassword: false,
				changePasswordRequestData: {},
				changePasswordRequestFailedData: action.payload
			}

		case actions.RESET_CHANGE_PASSWORD_REQUEST_DATA:
			return {
				...state,
				requestingChangePassword: false,
				changePasswordRequestData: {},
				changePasswordRequestFailedData: {},
			}

		case actions.GET_VERIFY_ACTIVATION_FAILED:
			return {
				...state,
				verfiyActivationValid: false
			}

		case actions.GET_VERIFY_ACTIVATION_FAILED:
			return {
				...state,
				verfiyActivationValid: false
			}

		case actions.DO_SET_PASSWORD_SUCCESS:
			return {
				...state,
				idToken: action.payload.token,
				setPasswordSucceeded: true
			}

		case actions.DO_SET_PASSWORD_FAILED:
			return {
				...state,
				setPasswordSucceeded: false
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/auth/reducer.js